import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, ShoppingCart, Pill, Users, CheckCircle2, XCircle } from 'lucide-react';
export function IncludesSection() {
  const includes = [{
    icon: <BookOpen className="w-6 h-6 text-emerald-600" data-id="element-42" />,
    title: 'La Guía Maestra del Protocolo',
    desc: 'El paso a paso para desinflamarte sin pasar hambre.'
  }, {
    icon: <Clock className="w-6 h-6 text-emerald-600" data-id="element-43" />,
    title: 'El Plan de Choque de 72 Horas',
    desc: 'El menú exacto para ver resultados visuales este mismo fin de semana.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-emerald-600" data-id="element-44" />,
    title: 'Lista de Compras "Supermercado Argentino"',
    desc: 'Qué comprar en Coto, Carrefour o el Chino para no fallar.'
  }, {
    icon: <Pill className="w-6 h-6 text-emerald-600" data-id="element-45" />,
    title: 'Protocolo de Suplementación Invisible',
    desc: 'Los 3 minerales clave que tu cuerpo necesita para soltar el líquido.'
  }, {
    icon: <Users className="w-6 h-6 text-emerald-600" data-id="element-46" />,
    title: 'Guía de Supervivencia Social',
    desc: 'Cómo ir a un asado o restaurante y seguir bajando de peso.'
  }];
  return <section className="py-20 bg-stone-50" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-50">
            Lo que obtienes hoy
          </h2>
          <p className="text-lg text-stone-600" data-id="element-51">
            Todo lo que necesitas para transformar tu cuerpo desde el día 1.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24" data-id="element-52">
          {includes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-stone-100 hover:shadow-md transition-shadow" data-id="element-53">
              <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-6" data-id="element-54">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-55">
                {item.title}
              </h3>
              <p className="text-stone-600" data-id="element-56">{item.desc}</p>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-57">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-emerald-100" data-id="element-58">
            <h3 className="text-2xl font-bold text-stone-900 mb-8 flex items-center" data-id="element-59">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mr-3 text-sm" data-id="element-60">
                ✓
              </span>
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-61">
              {['Personas mayores de 30 años que sienten que su metabolismo se "frenó".', 'Mujeres que sufren de distensión abdominal severa al final del día.', 'Hombres que buscan eliminar la "panza de estrés" sin horas de gimnasio.', 'Quienes sufren de niebla mental y cansancio después de almorzar.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-62">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-63" />
                  <span className="text-stone-700" data-id="element-64">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-red-100" data-id="element-65">
            <h3 className="text-2xl font-bold text-stone-900 mb-8 flex items-center" data-id="element-66">
              <span className="w-8 h-8 rounded-full bg-red-100 text-red-600 flex items-center justify-center mr-3 text-sm" data-id="element-67">
                ✕
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-68">
              {['Personas que buscan una solución mágica sin cambiar ni un solo hábito.', 'Fisicoculturistas que buscan ganar volumen muscular extremo.', 'Quienes no estén dispuestos a dejar los aceites vegetales por un mes.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-69">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-70" />
                  <span className="text-stone-700" data-id="element-71">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}